<template>
  <div style="margin:20px">
    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Booking Dispatch Board</span><br/>
      <span style="font-style: italic; font-size: 18px">shows active dispatch details</span>
      <span style="font-style: italic; font-size: 18px">click '+' for more details</span>
    </div>

    <div style="font-size: 22px; font-weight: bold; margin-top: 20px; position: relative" class="align-right d-flex align-items-center justify-content-center">
      <a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(-1)"><</a>
      &nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"/>
      &nbsp;to&nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_toDate" :config="options" :placeholder="details_toDate"/>
      &nbsp;<a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(1)">></a>
      &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;
      <b-button v-on:click.prevent="load_data()" :disabled="loading">Get Results</b-button> 
      <span v-if="(base_options && base_options.length > 2) && !is_driver_role()">
        &nbsp;&nbsp;<b-form-select v-model="selected_base" :options="base_options" style="font-size: 18px; font-weight: bold; width:200px"/>
      </span>
      <!-- <a href="#" class="arrows" v-on:click.prevent="shift_detail_graph_date(-1)"><</a>
      &nbsp;&nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"></date-picker>&nbsp;&nbsp;
      <a href="#" class="arrows" v-on:click.prevent="shift_detail_graph_date(1)">></a> -->
    </div>

    <div v-if="!loading">
      <div class="row" style="margin:30px; font-weight: bold; font-size: 24px;">
        <div class="col" style="padding:5px; border: 1px solid grey;">{{items.length}} results</div>
        <div class="col" style="padding:5px"><b-button v-on:click.prevent="load_data()">Reload</b-button></div>
        <!-- <div style="margin: 5px"><b-button size="md" variant="success" @click="download">Download</b-button></div>
        <div style="margin: 5px" @click="printPage()"><img height="30px" src="/print-icon.png"/></div> -->
      </div>
    </div>

    <!-- <vue-html2pdf
        :enable-download="true"
        :manual-pagination="true"
        :filename="'daily-dispatch-board-' + details_fromDate"
        pdf-format="letter"
        margin="0px"
        pdf-orientation="landscape"
        pdf-content-width="1050px"
        ref="html2Pdf"
    >
      <section slot="pdf-content">
        <html>
          <template v-for="page in Array(Math.ceil(items.length / 25)).keys()">
          <br/>
            <table border="1" v-if="summary">
              <tr style="font-size: 10px">
                <th>Booking</th>
                <th>Organization</th>
                <th>Requested Driver</th>
                
                <th>Trip Ref</th>
                <th>Pickup Location</th>
                <th>Destination</th>
                <th>Driver</th>
                <th>Price</th>
                <th>Miles</th>
                <th>Veh Type</th>
                <th width="70px">Driver Start</th>
                <th width="70px">Base of Operation</th>
                <th width="70px">Departure</th>
                <th width="70px">Arrival</th>
                <th width="70px">Driver End</th>
              </tr>
              <template v-if="idx >= (page * 25) && idx < ((page+1)*25)" v-for="(item,idx) in items">
                <tr>
                  <td style="font-size: 12px">{{item.booking_id}}</td>
                  <td style="font-size: 10px">{{item.organization | trim(28)}}</td>
                  <td style="font-size: 10px">{{item.requested_driver | trim(28)}}</td>
                  
                  <td style="font-size: 10px;">{{item.trip_reference | trim(28)}}</td>
                  <td style="font-size: 10px">{{item.first_pickup_location | trim(28)}}</td>
                  <td style="font-size: 10px">{{item.destination_location | trim(28)}}</td>
                  <td style="font-size: 10px">{{item.driver}}</td>
                  <td style="font-size: 12px">{{item.price}}</td>
                  <td style="font-size: 12px">{{item.miles}}</td>
                  <td style="font-size: 10px">{{item.vehicle_type}}</td>
                  <td style="font-size: 12px">{{item.driver_start}}</td>
                  <td style="font-size: 12px">{{item.base_of_operation}}</td>
                  <td style="font-size: 12px">{{item.departure_time}}</td>
                  <td style="font-size: 12px">{{item.arrival_time}}</td>
                  <td style="font-size: 12px">{{item.driver_end}}</td>
                </tr>
              </template>
            </table>
            <br/>
            <table width="1000px">
              <tr>
                <td>Page {{page+1}} of {{Math.ceil(items.length/25)}}</td>
                <td align="right">{{current_date}}</td>
              </tr>
            </table>

            <div v-if="page+1 != Math.ceil(items.length/25)" class="html2pdf__page-break"/>

          </template>
        </html>
      </section>
    </vue-html2pdf> -->

    <div v-if="summary && !loading">
      <b-table :busy="loading" sticky-header="70vh" striped bordered :items="items" :fields="fields"
               :current-page="currentPage" :tbody-tr-class="get_row_color"
               :per-page="perPage">

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>
        
        <!-- <template slot="status_msg" slot-scope="row">
          <div style="text-align: left" v-for="msg in row.item.status_msg.split(',')">
            <span v-html="msg"/>
          </div>
        </template> -->

        <template slot="booking_id" slot-scope="row">
          {{row.item.booking_id | trim(50)}}
        </template>
        <template slot="requested_driver" slot-scope="row">
          {{row.item.requested_driver | trim(50)}}
        </template>
        <template slot="first_pickup_location" slot-scope="row">
          {{findCityState(row.item.first_pickup_location)}}
        </template>
        <template slot="destination_location" slot-scope="row">
          {{findCityState(row.item.destination_location)}}
        </template>
         <template slot="driver_start" slot-scope="row">
          {{row.item.driver_start | trim(50)}}
        </template>
         <template slot="driver" slot-scope="row">
          {{row.item.driver | trim(40)}}
        </template>
         <template slot="price" slot-scope="row">
          {{row.item.price | trim(30)}}
        </template>
         <template slot="miles" slot-scope="row">
          {{row.item.miles | trim(30)}}
        </template>
         <template slot="vehicle_type" slot-scope="row">
          {{row.item.vehicle_type | trim(30)}}
        </template>

         <!-- <template slot="trip_reference" slot-scope="row">
          {{row.item.trip_reference | trim(50)}}
        </template> -->

        <template slot="details" slot-scope="row">
          <div style="align-content: center">
            <b-button size="sm" @click="row.toggleDetails">
              {{ row.detailsShowing ? '-' : '+' }}
            </b-button>&nbsp;
          </div>
        </template>

        <template slot="row-details" slot-scope="row">

          <div style="text-align: left; padding: 10px; margin:10px; border: 1px dotted grey">
            <table width="50%">
              <tr>
                <td style="text-align: left; width: 15px; padding: 4px;">Status</td>
                <td style="width: 15px;">
                  <select v-model="row.item.driver_status" @change="onChange(row)">
                    <option value="Available">Available</option>
                    <option value="OFF">OFF</option>
                  </select>
                </td>                
                <td style="text-align: left; width: 15px; padding: 4px;">Priority</td>
                <td style="width: 15px;">
                  <select v-model="row.item.rank" @change="onChange(row)">
                    <option value="">Select Priority</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                    <option value="9">9</option>
                    <option value="10">10</option>
                  </select>
                </td>
                <td style="text-align: left; width: 15px; padding: 4px;">Driver Acknowledged</td>
                <td style="text-align: left; width: 15px; padding: 4px;">
                  <input style="text-align: left; width: 15px;" type="checkbox" v-model="row.item.driver_ack"/>
                </td>
                <td style="text-align: left; width: 15px; padding: 4px;">
                  <button @click="submit(row)">Submit</button>
                </td>
                </tr>
                </table>
                <table width="100%"><tr>
                <td style="text-align: left;">Trip Reference</td>
                <td>{{row.item.trip_reference }}</td>
                <td style="text-align: left;">Booking ID</td>
                <td>{{row.item.booking_id }}</td>
                </tr><tr>
                <td style="text-align: left;">Organization</td>
                <td>{{row.item.organization }}</td>
                <td style="text-align: left;">Base of Operation</td>
                <td>{{row.item.base_of_operation }}</td>
                </tr><tr>
                <td style="text-align: left;">Pickup Location</td>
                <td>{{ row.item.first_pickup_location }}</td>
                <td style="text-align: left;">Destination Location</td>
                <td>{{row.item.destination_location }}</td>
              </tr>
            </table>


           
           
          </div>
        </template>


      </b-table>
      <b-row v-if="items.length > 10">
        <b-col>
          <b-pagination
              v-model="currentPage"
              :total-rows="items.length"
              :per-page="perPage"
              align="center"
          >
          </b-pagination>
        </b-col>
      </b-row>
    </div>
    <div v-else-if="loading">
      <div class="text-center text-danger my-2">
        <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
      </div>
    </div>
  </div>
</template>
        <!-- <template slot="row-details" slot-scope="row">
          <b-card style="background-color: white; text-align: left;">
            
            <b>Booking Details</b>
             
              <template slot="trip_reference" slot-scope="row">
                {{row.item.trip_reference }}
              </template>
              <template slot="organization" slot-scope="row">
                {{row.item.organization}}
              </template>
              <template slot="departure_time" slot-scope="row">
                {{row.item.departure_time }}
              </template>
              <template slot="arrival_time" slot-scope="row">
                {{row.item.arrival_time }}
              </template> -->
              <!-- <template slot="last_washed_time" slot-scope="row">
                {{row.item.last_washed_time | formatDateTimeCustom(summary.datetime_format)}}
              </template>
              <template slot="last_ready_time" slot-scope="row">
                {{row.item.last_ready_time | formatDateTimeCustom(summary.datetime_format)}}
              </template>
              <template slot="last_out_time" slot-scope="row">
                {{row.item.last_out_time | formatDateTimeCustom(summary.datetime_format)}}
              </template>
              <template slot="last_returned_time" slot-scope="row">
                {{row.item.last_returned_time | formatDateTimeCustom(summary.datetime_format)}}
              </template>
              <template slot="notes" slot-scope="row">
                <div style="margin:3px; text-align: left">{{row.item.notes}}</div>
              </template>
              <template slot="dump_date" slot-scope="row">
                {{row.item.dump_date | formatDateTimeCustom(summary.datetime_format)}}
              </template>

              <template slot="detailed_date" slot-scope="row">
                {{row.item.detailed_date | formatDateTimeCustom(summary.datetime_format)}}
              </template> -->

<script>

import {get_booking_bids_for_drivers_board, get_booking_bids_for_drivers_board_base, get_booking_bases, tbn_api_url} from "../networking/tbn_apis";
import {mapState} from "vuex";
import moment from 'moment';
import datetime from 'vuejs-datetimepicker';
import {justDate} from "../helpers/dates";
import axios from "axios";
import VueHtml2pdf from 'vue-html2pdf'

export default {
  name: 'dispatch_board_tbn',
  components: {
     datetime, VueHtml2pdf
  },
  metaInfo: {
    title: "Fleet Integrations",
    titleTemplate: "Fleet Integrations",
  },
  data() {
    return {
      search_filter: '',
      tenant_id: null,
      updating: false,
      reloading: false,
      current_date: moment().format('MMMM Do YYYY, h:mm:ss a'),
      details_fromDate: justDate(moment()),
      details_toDate: justDate(moment()),
      items: [],
      items_full: [],
      summary: null,
      loading: false,
      totalRows: 1,
      currentPage: 1,
      perPage: 300,
      pages: [],
      base_options: [],
      driver_options: [],
      selected_base: '',
      company_location: '',
      alert: {
        show: false,
        message: '',
        variant: ''
      },
      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment().subtract(30, 'days'),
        maxDate: moment().add(30, 'days'),
        keepOpen: false,
        showClear: true,
        showClose: true,
        toolbarPlacement: 'top',
      },
      rows: [
        { id: 1, name: 'Alice', status: 'Active' },
        { id: 2, name: 'Bob', status: 'Inactive' }
      ],
      fields: [
        { key: 'details', label: '', sortable: false, thStyle: { width: '9px', maxWidth: '11px' }},
        { key: 'booking_id', sortable: true, visible: true, thStyle: { width: "80px" }},
        //{ key: 'organization', sortable: true, visible: true, thStyle: { width: "180px" }},
        { key: 'requested_driver', sortable: true, visible: true, thStyle: { width: "100px" }},
        // { key: 'group_name', sortable: true, visible: true, thStyle: { width: "150px" }},
        //{ key: 'trip_reference', sortable: true, visible: true, thStyle: { width: "200px" }},
        { key: 'first_pickup_location', sortable: true, visible: true, thStyle: { width: "200px" }},
        { key: 'destination_location', sortable: true, visible: true, thStyle: { width: "200px" }},
        { key: 'driver_start', sortable: true, visible: true, thStyle: { width: "100px" }},
        { key: 'driver', sortable: true, visible: true, thStyle: { width: "100px" }},
        { key: 'price', sortable: true, visible: true, thStyle: { width: "60px" }},
        { key: 'miles', sortable: true, visible: true, thStyle: { width: "60px" }},
        { key: 'vehicle_type', sortable: true, visible: true,  thStyle: { width: "80px" }},
        //{ key: 'base_of_operation', sortable: true, visible: true, thStyle: { width: "200px" }},
        //{ key: 'departure_time', label: 'First Departure', sortable: true, visible: true},
        //{ key: 'arrival_time', label: 'Last Arrival', sortable: true, visible: true},
        //{ key: 'driver_end', sortable: true, visible: true, thStyle: { width: "200px" }}
      ],
    }
  },
  async created() {
    this.tenant_id = this.user.tenant
    this.fields_all = this.fields
    await this.setup_bases()
    this.setup_to_from_bid_dates()
    await this.check_features()
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    printPage() {
      this.$refs.html2Pdf.generatePdf()
    },
    async shift_detail_graph_date(shift) {
      this.details_fromDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
      this.details_toDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
    },
    showAlert(msg, variant, autoclose) {
      this.alert.show = true
      this.alert.message = msg
      this.alert.variant = variant
      autoclose
          ? setTimeout(() => this.closeAlert(), autoclose)
          : null
    },
    closeAlert() {
      this.alert.show = false
      this.alert.message = ''
      this.alert.variant = ''
    },
    async check_features() {
      this.fields = this.fields_all
      //this.load_data()
      this.driver_options = []
      this.company_location = this.user.company_location
      // try {
      //   const {value: {data = []}} = await get_driver_list(this.user.tenant)
      //   this.driver_options = data
      // } catch(e) {
      //   this.$emit('showAlert', 'error loading data, try logging in again or contact support if needed', 'danger', 5000)
      // }
    },
    get_row_color_2(item) {
      if (item.row_id % 2 == 0) {
        console.log("rc: " + item.row_id);
        return "rowgray";
      }
    },
    get_row_color(item, type) {
      if (!item || type !== 'row') return
        return item.status
    },
    is_driver_role() {
      return this.user.role == 'driver-bid-driver'
    },
    async load_data() {
      this.loading = true
      try {
        var results = null
        console.log('role: ' + this.user.role + ", location: " + this.company_location)
        if (this.user.role == 'driver-bid-driver' && this.company_location && this.company_location != '') {
          results = await get_booking_bids_for_drivers_board_base(this.tenant_id, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'), this.company_location)

        } else {
          results = await get_booking_bids_for_drivers_board(this.tenant_id, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))
        }
        // var results = await get_booking_bids_for_drivers_board(this.tenant_id, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))
        const {value: { data = [] } } = results

        this.summary = data.summary
        moment.tz.setDefault(this.summary.timezone)
        this.items = data.results
        this.items_full = data.results
        console.log('got results base options: ' + this.summary.base_options)
        this.base_options = this.summary.base_options
        if (this.selected_base != '') {
          this.items = this.items.filter(item => item.base_of_operation.indexOf(this.selected_base) != -1)
        }
        //console.log(this.parseCityState("123 Main St, Anytown, CA 91234"));
        //console.log(this.findCityState("123 Main St, Anytown, CA 91234"));

      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.loading = false
    },
    filter_results() {
      this.items = this.items_full
      if (!this.items)
        return
      if (this.selected_base != '') {
        this.items = this.items.filter(item => item.base_of_operation.indexOf(this.selected_base) != -1)
      }
    },
    onChange(row) {
      console.log('Updated:', row)
    },
    setup_to_from_bid_dates() {
      console.log('setup_to_from_bid_dates'); 
      const today = new Date();
      const dayOfWeekNumber = today.getDay();

      console.log('dayOfWeekNumber' +dayOfWeekNumber); 
      // Example output: 3 (if today is Wednesday)
      if (dayOfWeekNumber == 4) {
        console.log("it's thursday")
        this.details_fromDate = moment(justDate(moment()), 'MM-DD-YYYY').add(3, 'days').format('MM-DD-YYYY');
        this.details_toDate = moment(justDate(moment()), 'MM-DD-YYYY').add(4, 'days').format('MM-DD-YYYY');
      } else if (dayOfWeekNumber == 5) {
        console.log("it's friday")
        this.details_fromDate = moment(justDate(moment()), 'MM-DD-YYYY').add(3, 'days').format('MM-DD-YYYY');
        this.details_toDate = moment(justDate(moment()), 'MM-DD-YYYY').add(4, 'days').format('MM-DD-YYYY');
      } else {
        this.details_fromDate = moment(justDate(moment()), 'MM-DD-YYYY').add(3, 'days').format('MM-DD-YYYY');
        this.details_toDate = moment(justDate(moment()), 'MM-DD-YYYY').add(3, 'days').format('MM-DD-YYYY');
      }
    },
    async setup_bases() {
      try {
        var bases = null
        bases = await get_booking_bases(this.tenant_id)
        const { value: { data = [] } } = bases
        this.bases = data.summary
        console.log('NEW got results base options: ' + this.bases.base_options)
        this.base_options = this.bases.base_options
        if (this.selected_base != '') {
          this.items = this.items.filter(item => item.base_of_operation.indexOf(this.selected_base) != -1)
        }
      } catch (e) {
        console.log(e)
        this.$emit('showAlert', 'error retrieving bases, try logging in again or contact support if needed', 'danger', 5000)
      }
    },
    findCityState(input) {
      //console.log('address: ' + input)
      if (!input) return null

      const text = input.replace(/\s+/g, ' ').trim()
      const STATES = [
        ['AL', 'Alabama'], ['AK', 'Alaska'], ['AZ', 'Arizona'], ['AR', 'Arkansas'],
        ['CA', 'California'], ['CO', 'Colorado'], ['CT', 'Connecticut'],
        ['DE', 'Delaware'], ['FL', 'Florida'], ['GA', 'Georgia'],
        ['HI', 'Hawaii'], ['ID', 'Idaho'], ['IL', 'Illinois'], ['IN', 'Indiana'],
        ['IA', 'Iowa'], ['KS', 'Kansas'], ['KY', 'Kentucky'], ['LA', 'Louisiana'],
        ['ME', 'Maine'], ['MD', 'Maryland'], ['MA', 'Massachusetts'],
        ['MI', 'Michigan'], ['MN', 'Minnesota'], ['MS', 'Mississippi'],
        ['MO', 'Missouri'], ['MT', 'Montana'], ['NE', 'Nebraska'],
        ['NV', 'Nevada'], ['NH', 'New Hampshire'], ['NJ', 'New Jersey'],
        ['NM', 'New Mexico'], ['NY', 'New York'], ['NC', 'North Carolina'],
        ['ND', 'North Dakota'], ['OH', 'Ohio'], ['OK', 'Oklahoma'],
        ['OR', 'Oregon'], ['PA', 'Pennsylvania'], ['RI', 'Rhode Island'],
        ['SC', 'South Carolina'], ['SD', 'South Dakota'], ['TN', 'Tennessee'],
        ['TX', 'Texas'], ['UT', 'Utah'], ['VT', 'Vermont'],
        ['VA', 'Virginia'], ['WA', 'Washington'], ['WV', 'West Virginia'],
        ['WI', 'Wisconsin'], ['WY', 'Wyoming']
      ]

      for (const [abbr, full] of STATES) {
        // Match "City, ST" or "City ST"
        const abbrRegex = new RegExp(
          `([A-Za-z .'-]+?),?\\s+${abbr}\\b`,
          'i'
        )

        const fullRegex = new RegExp(
          `([A-Za-z .'-]+?),?\\s+${full}\\b`,
          'i'
        )

        let match = text.match(abbrRegex) || text.match(fullRegex)

        if (match) {
          const city = match[1].trim()
          return city +', ' + abbr
          //return { city, state: abbr }
        }
      }

      return input
    },
    async download(){
      this.$emit('showAlert', 'processing download request', 'info', 5000)
      axios.defaults.headers.common.Accept = {}
      axios.post(
          `${tbn_api_url}tbn/dispatch_board/download`,
          {
            tenant: this.tenant_id,
            date: moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
          }, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('jwt')}`,
              Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            },
            responseType: 'blob'
          }
      ).then((response) => {
        axios.defaults.headers.common.Accept = 'application/json'
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute(
            'download',
            `dispatch-board-${this.user.tenant}-${this.details_fromDate}.csv`
        )
        document.body.appendChild(link)
        link.click()
        this.$emit('showAlert', 'download complete', 'success', 5000)
      }).catch(e => {
        axios.defaults.headers.common.Accept = 'application/json'
        this.$emit('showAlert', 'data could not be downloaded.', 'danger')
      })
    },
  },
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
    visibleFields() {
      var custom_fields = null;

      if (this.summary && this.summary.visible_fields)
        custom_fields = this.summary.visible_fields;

      if (custom_fields != null) {
        let new_fields = []
        for (let visible_field of custom_fields.split(",")) {
          let found_field = this.fields_all.filter(field => visible_field == field.key)
          if (found_field.length > 0) {
            new_fields.push(found_field[0]);
          }
        }
        return new_fields;
      } else
        return this.fields.filter(field => field.visible)
    },

  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.check_features()
      }
    },
    details_fromDate() {
      //this.load_data();
    },
    selected_base() {
      this.filter_results()
    }
  },
  // mounted() {
  // this.$nextTick(() => {
  //   this.$refs.table.toggleRowDetails(0)
  // })
  // }
}
</script>

<style scoped>

.rowgray { background-color: #f2f2f2}


td:first-child {
    font-weight: bold;
  }
.b_bold {
 font-weight: bold;
}
td:nth-child(3) {
    font-weight: bold;
  }
/* td select {
  width: 90%;
  padding: 4px;
} */
</style>

